/**
 * LeaderboardTable.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { NavLink } from '@minerva-analytics/pantheon';

import event from 'utils/event';

import {
  Row,
  THeader,
  Body,
  Container,
  StyledTD,
  StyledTH,
  StyledTable,
} from './LeaderboardTable.styles';

/**
 * lala
 */
export default class LeaderboardTable extends Component {
  static propTypes = {
    data: PropTypes.array,
    user: PropTypes.object,
    linkToUsers: PropTypes.bool,
  }

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  onClick = (id) => {
    event(`friend-click`, [`click`, `friend-click`, `${id}`]);
  }

  render() {
    const { data, user, linkToUsers } = this.props;

    const players = data.map((p) => {
      return (
        <Row
          bolded={ user && p.id === user.id }
          key={ p.id }
        >
          <StyledTD>
            {p.rank}
          </StyledTD>

          <StyledTD breakWord>
            {
              linkToUsers
                ? <NavLink
                  onClick={ () => this.onClick(p.id) }
                  to={ `/profile/${p.id}` }
                > {p.username} </NavLink>
                : p.username
            }
          </StyledTD>
          <StyledTD>
            { (p.percent_correct * 100).toFixed() }%
          </StyledTD>
          <StyledTD>
            { p.score }
          </StyledTD>
        </Row>
      );
    });
    return (
      <Container>
        <StyledTable>
          <colgroup>
            <col width="12%" />
            <col width="58%" />
            <col width="15%" />
            <col width="15%" />
          </colgroup>
          <THeader>
            <Row>
              <StyledTH>Rank</StyledTH>
              <StyledTH>Username</StyledTH>
              <StyledTH>Percent</StyledTH>
              <StyledTH>Score</StyledTH>
            </Row>
          </THeader>
          <Body>
            { players }
          </Body>
        </StyledTable>
      </Container>
    );
  }
}
